"use client";
import { jsx as s } from "react/jsx-runtime";
import { css as t } from "@emotion/react";
import a from "@emotion/styled";
import { DIVIDER_COLORS as p } from "../../tokens/divider-colors/DividerColors.js";
import { SPACINGS as d } from "../../tokens/spacings/Spacings.js";
import { forwardRef as h } from "react";
const e = h(
  ({ as: o = "hr", feColor: r = "primary", feSpacing: i = "md", feVertical: m = !1, ...l }, n) => /* @__PURE__ */ s(
    c,
    {
      ...l,
      as: o,
      "data-comp": "divider",
      feColor: r,
      feSpacing: i,
      feVertical: m,
      ref: n
    }
  )
);
e.displayName = "Divider";
const k = e, c = a.hr(({ feColor: o, feInset: r, feSpacing: i, feVertical: m }) => {
  if (!(!o || !i))
    return t`
		background-color: ${p[o]};
		border: 0;

		${!m && t`
			height: 1px;
			margin-block: ${d[i]};
			margin-inline: ${r && d[r]};
		`}

		${m && t`
			align-self: stretch;
			display: flex;
			flex-shrink: 0; /* Prevents shrink when flex-child */
			margin-block: ${r && d[r]};
			margin-inline: ${d[i]};
			width: 1px;
		`}
	`;
});
export {
  k as default
};
